<script lang="ts">
  import { Button } from "$lib/ui/button";
  import { DrawerContent, DrawerDescription, DrawerFooter, DrawerHeader, DrawerTitle } from "$lib/ui/drawer";

  interface Props {
    connectionId: string;
    successActionButtonText: string;
    successAction: () => Promise<void>;
  }

  let { connectionId, successActionButtonText, successAction }: Props = $props();
</script>

<DrawerHeader class="pt-8 px-6 pb-4 relative">
  <DrawerTitle class="text-3xl text-left">Connection successful</DrawerTitle>
</DrawerHeader>

<div class="my-5 gap-6 px-6 overflow-y-auto grow">
  <DrawerDescription>
    {connectionId} has been successfully connected to Permissions Assurance.
  </DrawerDescription>
  <div class="flex flex-col px-6 mt-5"></div>
</div>
<DrawerFooter class="px-6">
  <Button on:click={successAction}>
    <div class="flex items-center">
      <span>{successActionButtonText}</span>
    </div>
  </Button>
</DrawerFooter>
